import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Col, DatePicker, Form, Input, message, Row, Select, Space, Spin} from 'antd';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import ReactQuill from 'react-quill';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import {
  fetchNalcoRateList,
  resetNalcoRateList,
  resetCurrentNalcoRatePage,
  fetchNalcoRateForQuotation,
} from '../../slices/nalco-rate';

import { createProforma } from '../../slices/proforma';
import {
  fetchWorkOrderDropdown,
  resetWorkOrderList,
} from '../../slices/proforma';
import {
  fetchAlloyDropdown,
  resetAlloyList,
  resetCurrentAlloyListPage,
} from '../../slices/alloy';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import {
  fetchTemperDropdown,
  resetCurrentTemperPage,
  resetTempersList,
} from '../../slices/tempers';
import {
  fetchCustomerDropdown,
  resetCustomerList,
} from './../../slices/customer';
import {
  fetchDieProfileDropdown,
  fetchDieProfileById,
  resetCurrentDieProfilePage,
  resetDieProfileList,
} from './../../slices/die-profile';
import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';
const { Option } = Select;
import { debounce } from 'lodash';
import { fetchPackingModeList, resetPackingModeData } from '../../slices/packing';
import { fetchjobWorkList, resetJobWorkList } from '../../slices/job-work';

function CreateProforma() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [editorValue, setEditorValue] = useState('');
  const [btnLoading, setBtnLoading] = useState(false);
  const [searchCustomer, setSearchCustomer] = useState('');
  const [searchTemper, setSearchTemper] = useState('');
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [serahcNalcoRate, setSearchNalcoRate] = useState('');
  const [searchAlloy, setSearchAlloy] = useState('');
  const [isDropdownLoading, setIsDropdownLoading] = useState(false);

  const {
    workOrderList: workOrderList = [],
    workOrderLoading: workOrderLoading,
    workOrderCurrentPage: workOrderCurrentPage,
    workOrderHasMore: workOrderHasMore,
  } = useSelector(state => state.proforma);
  const [nalcoRate, setNalcoRate] = useState([]);
  const [selectedJobWork, setSelectedJobWork] = useState('');
  const [selectedSurfaceFinish, setSelectedSurfaceFinish] = useState('');
  const [selectedEngineeringOptions, setSelectedEngineeringOptions] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);

  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const {
    list: customerList,
    loading: customerLoading,
    currentpage: resetCurrentCustomerPage,
    hasMore: customerHasMore,
  } = useSelector(state => state.customer);
  
  const {
    list: dieProfileList,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);
  const { data: packingModeList, loading: packingModeLoading } = useSelector(state => state.packingMode);
  const { data: settingData } = useSelector(state => state.setting);
  const { jobWorkdata, loading: jobWorkLoading } = useSelector(state => state.jobWork);
  const {
    list: NalcoRateList,
    loading: NalcoRateLoading,
    currentPage: NalcoRateCurrentPage,
    hasMore: NalcoRateHasMore,
  } = useSelector(state => state.nalcoRate);

  const {
    list: alloyList,
    loading: alloyLoading,
    currentPage: alloyCurrentPage,
    hasMore: alloyHasMore,
  } = useSelector(state => state.alloy);
  const {
    list: temperList,
    loading: temperLoading,
    currentPage: temperCurrentPage,
    hasMore: temperHasMore,
  } = useSelector(state => state.temper);

  const handleWorkOrderSelect = async workOrderId => {
    const selectedWorkOrder = workOrderList.find(wo => wo.id === workOrderId);
   
    if (selectedWorkOrder) {
      form.setFieldsValue({
        workorder_no: selectedWorkOrder.order_no,
        customer: selectedWorkOrder.bill_to.id,
        packing_mode: selectedWorkOrder?.packing_mode,
        proforma_date: dayjs(),
        freight_charges: selectedWorkOrder.freight_charges || '',
        advance_amount: selectedWorkOrder.advance_amount || '',
        delivery_schedule: selectedWorkOrder.delivery_schedule || '',
        weight_range: selectedWorkOrder.weight_range || '',
        remarks: selectedWorkOrder.remarks || '',
        proforma_details: selectedWorkOrder?.work_order_details.map(detail => ({
          profile_no: detail.die_profile ? detail.die_profile.id : '',
          alloy: detail.alloy ? detail.alloy.id : '',
          temper: detail.temper ? detail.temper.id : '',
          customer_reference_no: detail.customer_reference_number || '',
          jobworks: detail.jobworks || '',
          length: detail.length ? detail.length : '',
          nalco_rate: nalcoRate || '',
          dispatch_qty: detail.dispatched_pieces || '',
          conversion: detail?.conversion || '',
          net_weight: detail.net_weight ? parseFloat(detail.net_weight).toFixed(3) : '',
          packed_weight: detail.packed_weight ? parseFloat(detail.packed_weight).toFixed(3) : '',
          pieces: detail.packed_pieces || '',
        })) || [
            {
              profile_no: '',
              alloy: '',
              temper: '',
              customer_reference_no: '',
              jobworks: '',
              length: '',
              nalco_rate: nalcoRate,
              dispatch_qty: '',
              net_weight: '',
              packed_weight: '',
              pieces: '',
            },
          ],
      });
      setSearchCustomer(selectedWorkOrder?.bill_to?.customer_name);

      // const proformaDetails = selectedWorkOrder.work_order_details || [];
      // for (let index = 0; index < proformaDetails.length; index++) {
      //   const detail = proformaDetails[index];
      //   if (detail.die_profile?.id) {
      //     try {
      //       const response = await dispatch(fetchDieProfileById(detail.die_profile.id)).unwrap();
      //       if (response?.results?.data?.length > 0) {
      //         const wtKgPerMt = response.results.data[0]?.wt_kg_p_mt || '';
      //         const updatedProformaDetails = form.getFieldValue('proforma_details') || [];
      //         updatedProformaDetails[index] = {
      //           ...updatedProformaDetails[index],
      //           wt_kg_p_mt: wtKgPerMt ? parseFloat(wtKgPerMt).toFixed(3) : '',
      //         };
      //         form.setFieldsValue({
      //           proforma_details: updatedProformaDetails,
      //         });

      //         if (updatedProformaDetails[index].length && updatedProformaDetails[index].pieces) {
      //           handleFieldChange(index, 'length');
      //         }
      //       }
      //     } catch (error) {
      //       console.error('Error fetching die profile details:', error);
      //     }
      //   }
      // }
    }
  };

  useEffect(() => {
    dispatch(
      fetchCustomerDropdown({
        page: 1,
        pagesize: 1000,
        ...(search && { search: search }),
        ...(orderBy && { ordering: orderBy }),
      }),

      dispatch(
        fetchAlloyDropdown({
          page: 1,
          pagesize: 1000,
          ...(search && { search: search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      ),
      dispatch(
        fetchNalcoRateList({
          page: 1,
          pagesize: 1000,
          ...(search && { search: search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      ),
      dispatch(
        fetchTemperDropdown({
          page: 1,
          pagesize: 1000,
          ...(search && { search: search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      ),
      dispatch(
        fetchWorkOrderDropdown({
          page: 1,
          pagesize: 100,
          ...(search && { search: search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      ),
    );
    dispatch(fetchPackingModeList({ page: 1, pagesize: 100 }));
    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 50000,
        ...(search && { search: search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
    dispatch(fetchjobWorkList());
    dispatch(resetJobWorkList());
    dispatch(resetDieProfileList());
    dispatch(resetCustomerList());
    dispatch(resetPackingModeData());
    dispatch(resetAlloyList());
    dispatch(resetTempersList());
    dispatch(resetNalcoRateList());
    dispatch(resetWorkOrderList());
    dispatch(resetDieProfileList());
  }, [dispatch, page, pagesize, search, orderBy]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dispatch(
          fetchNalcoRateForQuotation(),
        );
        if (response?.payload?.data?.rate) {
          setNalcoRate(response.payload.data.rate);

          const currentValues = form.getFieldsValue();
          const currentProformaDetails = currentValues.proforma_details || [];

          const updatedProformaDetails = currentProformaDetails.map(detail => ({
            ...detail,
            nalco_rate: response.payload.data.rate,
          }));

          form.setFieldsValue({
            proforma_details: updatedProformaDetails,
          });
        } else {
          console.error('Unexpected response structure:', response);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [dispatch, form]);

  useEffect(() => {
      const terms =
        settingData?.term_and_condition_settings?.proforma_terms_and_conditions;
  
      if (terms) {
        setEditorValue(terms);
  
        // VERY IMPORTANT for AntD Form
        form.setFieldsValue({
          terms_and_condition: terms,
        });
      }
    }, [settingData, form]);

  const handleSearchCustomer = value => {
    setSearchCustomer(value);

    if (value) {
      setSearchCustomer(value);
      dispatch(resetCustomerList());
      dispatch(fetchCustomerDropdown({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchCustomer('');
      dispatch(resetCustomerList());
      dispatch(resetCurrentCustomerPage());
      dispatch(fetchCustomerDropdown({ page: 1, pagesize: 1000 }));
    }
  };

  const handleDropdownVisibleChange = open => {
    if (open && workOrderList.length === 0) {
      setIsDropdownLoading(true);
      setTimeout(() => {
        setIsDropdownLoading(false);
      }, 6000);
    }
  };
  const handleChangeCustomer = value => {
    setSearchCustomer(value);
  };
  const handleChange = value => {
    setEditorValue(value);
    form.setFieldsValue({ terms_and_condition: value });
  };

  const handleDieProfileChange = async (value, index) => {
    const updatedProformaDetails = [...form.getFieldValue('proforma_details')];
    updatedProformaDetails[index] = {
      ...updatedProformaDetails[index],
      profile_no: value?.value || null,
      customer_reference_no: '',
      wt_kg_p_mt: '',
    };
    form.setFieldsValue({
      proforma_details: updatedProformaDetails,
    });
    setSelectedIndex(index);

    try {
      const response = await dispatch(
        fetchDieProfileById(value?.value),
      ).unwrap();
      if (response?.results?.data?.length > 0) {
        const customerRefNo =
          response.results.data[0]?.customer_reference_number || '';
        const wtKgPerMt = response.results.data[0]?.wt_kg_p_mt || '';

        updatedProformaDetails[index] = {
          ...updatedProformaDetails[index],
          customer_reference_no: customerRefNo,
          wt_kg_p_mt: wtKgPerMt,
        };

        form.setFieldsValue({
          proforma_details: updatedProformaDetails,
        });
      }
    } catch (error) {
      console.error('Error fetching die profile details:', error);
    }
  };

  const handleCheckboxJobWorkChange = (field, checked, rowIndex) => {
    const updatedWorkOrderDetails = [...form.getFieldValue('proforma_details')];

    if (['cutting', 'machinings', 'deburring'].includes(field)) {
      setSelectedEngineeringOptions(prev => {
        const prevSelected = prev[rowIndex] || [];
        let newSelected;
        if (checked) {
          newSelected = [...prevSelected, field];
        } else {
          newSelected = prevSelected.filter(f => f !== field);
        }
        return {
          ...prev,
          [rowIndex]: newSelected,
        };
      });
    }

    if (['anodising', 'powder_coating', 'pvdf'].includes(field)) {
      setSelectedSurfaceFinish(prev => {
        const prevSelected = prev[rowIndex] || [];
        let newSelected;
        if (checked) {
          newSelected = [...prevSelected, field];
        } else {
          newSelected = prevSelected.filter(f => f !== field);
        }
        return {
          ...prev,
          [rowIndex]: newSelected,
        };
      });
    }

    updatedWorkOrderDetails[rowIndex] = {
      ...updatedWorkOrderDetails[rowIndex],
      [field]: checked,
    };

    form.setFieldsValue({
      proforma_details: updatedWorkOrderDetails,
    });
  };

  
  const onScrollDieProfile = async event => {
    const target = event.target;
    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchDieProfileDropdown({ page: dieProfileCurrentPage, pagesize: 5000 }),
      );
    }
  };

  const handleSearchDieProfile = value => {
    setSearchDieProfile(value);
    if (value) {
      setSearchDieProfile(value);
      dispatch(resetDieProfileList());
      dispatch(
        fetchDieProfileDropdown({ page: 1, pagesize: 5000, search: value }),
      );
    } else {
      setSearchDieProfile('');
      dispatch(resetDieProfileList());
      dispatch(resetCurrentDieProfilePage());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 5000 }));
    }
  };

  const onScrollWorkOrder = async event => {
    const target = event.target;
    if (
      !workOrderLoading &&
      workOrderHasMore &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight - 10
    ) {
      try {
        await dispatch(
          fetchWorkOrderDropdown({
            page: workOrderCurrentPage + 1,
            pagesize: 100,
            ...(search && { search: search }),
            ...(orderBy && { ordering: orderBy }),
          }),
        ).unwrap();
      } catch (error) {
        message.error('Failed to load more work orders.');
      }
    }
  };

  const handleSearchAlloy = value => {
    setSearchAlloy(value);
    if (value) {
      setSearchAlloy(value);
      dispatch(resetAlloyList());
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchAlloy('');
      dispatch(resetAlloyList());
      dispatch(resetCurrentAlloyListPage());
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 1000 }));
    }
  };

  const onScrollAlloy = async event => {
    const target = event.target;
    if (
      !alloyLoading &&
      alloyHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchAlloyDropdown({ page: alloyCurrentPage, pagesize: 1000 }));
    }
  };

  const handleSearchTemer = value => {
    setSearchTemper(value);
    if (value) {
      setSearchTemper(value);
      dispatch(resetTempersList());
      dispatch(fetchTemperDropdown({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchTemper('');
      dispatch(resetTempersList());
      dispatch(resetCurrentTemperPage());
      dispatch(fetchTemperDropdown({ page: 1, pagesize: 1000 }));
    }
  };

  const onScrollTemper = async event => {
    const target = event.target;
    if (
      !temperLoading &&
      temperHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchTemperDropdown({ page: alloyCurrentPage, pagesize: 1000 }));
    }
  };

  const workOrderFormItem = (
    <Form.Item name="workorder" label="Select Work Order">
      <AutoOpenSelect
        placeholder="Order No - Order Date - PO Number - PO Date - Customer Name"
        onChange={handleWorkOrderSelect}
        showSearch
        optionFilterProp="children"
        onDropdownVisibleChange={handleDropdownVisibleChange}
        onPopupScroll={onScrollWorkOrder} // Add scroll handler
        notFoundContent={
          isDropdownLoading || workOrderLoading ? (
            <div style={{ textAlign: 'center', padding: '16px' }}>
              <Spin size="small" />
            </div>
          ) : (
            'No options'
          )
        }
      >
        {workOrderList.map(wo => (
          <Option key={wo.id} value={wo.id} disabled={wo.deleted === 1}>
            {`${wo?.order_no} - ${wo?.order_date} - ${wo?.purchase_order_no} - ${wo?.purchase_order_date} - ${wo?.bill_to?.customer_name}`}
          </Option>
        ))}
      </AutoOpenSelect>
    </Form.Item>
  );

  const handleFieldChange = (index, changedField) => {
    const proformaDetails = form.getFieldValue('proforma_details') || [];
    const row = { ...proformaDetails[index] } || {};
    const currentKg = parseFloat(row.wt_kg_p_mt) || 0;
    const length = parseFloat(row.length) || 0;
    const pieces = parseFloat(row.pieces) || 0;
    const netWeight = parseFloat(row.net_weight) || 0;

    let updatedRow = { ...row };

    if (currentKg > 0 && length > 0 && pieces >= 0) {
      if (changedField === 'net_weight' && netWeight > 0) {
        const calculatedPieces = netWeight / (currentKg * (length / 1000));
        updatedRow.pieces = Math.round(calculatedPieces);
        updatedRow.net_weight = netWeight.toFixed(2);
      } else if (changedField === 'pieces' || changedField === 'length') {
        const calculatedNetWeight = ((currentKg * length) / 1000) * pieces;
        updatedRow.net_weight = calculatedNetWeight.toFixed(2);
      }
    }

    const updatedProformaDetails = [...proformaDetails];
    updatedProformaDetails[index] = updatedRow;

    form.setFieldsValue({
      proforma_details: updatedProformaDetails,
    });
  };


  const handleJobWorkChange = (value, rowIndex) => {
    const updatedWorkOrderDetails = [...form.getFieldValue('proforma_details')];

    const currentRow = updatedWorkOrderDetails[rowIndex] || {};
    const jobWorkIdToName = Object.fromEntries(jobWorkdata?.map(item => [item.id, item.name]));
    const selectedNames = value.map(id => jobWorkIdToName[id]);
    updatedWorkOrderDetails[rowIndex] = {
      ...currentRow,
      jobworks: value,
    };

    if (selectedNames.includes('Engineering')) {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        cutting: currentRow.cutting || false,
        machinings: currentRow.machinings || false,
        deburring: currentRow.deburring || false,
        cutting_price: currentRow.cutting_price || undefined,
        machinings_price: currentRow.machinings_price || undefined,
        deburring_price: currentRow.deburring_price || undefined,
      };
    } else {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        cutting: false,
        machinings: false,
        deburring: false,
        cutting_price: undefined,
        machinings_price: undefined,
        deburring_price: undefined,
      };
      setSelectedEngineeringOptions(prev => ({
        ...prev,
        [rowIndex]: [],
      }));
    }

    if (selectedNames.includes('Laser marking')) {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        laser_marking_description:
          currentRow.laser_marking_description || undefined,
        laser_marking_price: currentRow.laser_marking_price || undefined,
      };
    } else {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        laser_marking_description: undefined,
        laser_marking_price: undefined,
      };
    }

    if (!selectedNames.includes('Out Source')) {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        out_source: null,
      };
    } else {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        out_source: currentRow.out_source !== undefined ? currentRow.out_source : false,
      };
    }


    if (selectedNames.includes('Surface treatment')) {
      const surfaceFinishArray = [];
      if (currentRow.anodising) surfaceFinishArray.push('anodising');
      if (currentRow.powder_coating) surfaceFinishArray.push('powder_coating');
      if (currentRow.pvdf) surfaceFinishArray.push('pvdf');

      setSelectedSurfaceFinish(prev => ({
        ...prev,
        [rowIndex]: surfaceFinishArray,
      }));

      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        anodising: currentRow.anodising || false,
        powder_coating: currentRow.powder_coating || false,
        pvdf: currentRow.pvdf || false,
        anodising_description: currentRow.anodising_description || undefined,
        anodising_price: currentRow.anodising_price || undefined,
        powder_coating_description: currentRow.powder_coating_description || undefined,
        powder_coating_price: currentRow.powder_coating_price || undefined,
        pvdf_description: currentRow.pvdf_description || undefined,
        pvdf_price: currentRow.pvdf_price || undefined,
      };
    } else {
      setSelectedSurfaceFinish(prev => ({
        ...prev,
        [rowIndex]: [],
      }));

      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        anodising: false,
        powder_coating: false,
        pvdf: false,
        anodising_description: undefined,
        anodising_price: undefined,
        powder_coating_description: undefined,
        powder_coating_price: undefined,
        pvdf_description: undefined,
        pvdf_price: undefined,
      };
    }

    form.setFieldsValue({
      proforma_details: updatedWorkOrderDetails,
    });

    setSelectedJobWork(prev => ({
      ...prev,
      [rowIndex]: selectedNames,
    }));
  };

  const handleFinish = values => {
    setBtnLoading(true);
    values.proforma_date = dayjs(values.proforma_date).format('YYYY-MM-DD');

    const transformedProformaDetails = values.proforma_details.map(detail => {
      const transformedDetail = {
        id: detail ? detail.id : null,
        alloy: detail.alloy
          ? typeof detail.alloy === 'object'
            ? detail.alloy.value
            : detail.alloy
          : null,
        temper: detail.temper
          ? typeof detail.temper === 'object'
            ? detail.temper.value
            : detail.temper
          : null,
        profile_no: detail.profile_no
          ? typeof detail.profile_no === 'object'
            ? detail.profile_no.value
            : detail.profile_no
          : null,
        customer_reference_no: detail.customer_reference_no,
        jobworks: Array.isArray(detail.jobworks) ? detail.jobworks : [],
        length: parseInt(detail.length),
        pieces: parseInt(detail.pieces),
        dispatch_qty: parseFloat(detail.dispatch_qty),
        //conversion: detail?.conversion,
        nalco_rate: parseFloat(detail.nalco_rate),
        net_weight: parseFloat(detail.net_weight),
        packed_weight: parseFloat(detail.packed_weight),
      };

      if (detail.jobworks && detail.jobworks.includes(2)) {
        transformedDetail.cutting = detail.cutting || false;
        transformedDetail.machinings = detail.machinings || false;
        transformedDetail.deburring = detail.deburring || false;
        transformedDetail.cutting_price = detail.cutting_price
          ? parseFloat(detail.cutting_price)
          : undefined;
        transformedDetail.machinings_price = detail.machinings_price
          ? parseFloat(detail.machinings_price)
          : undefined;
        transformedDetail.deburring_price = detail.deburring_price
          ? parseFloat(detail.deburring_price)
          : undefined;
      }

      if (detail.jobworks && detail.jobworks.includes(1)) {
        transformedDetail.anodising = detail.anodising || false;
        transformedDetail.powder_coating = detail.powder_coating || false;
        transformedDetail.pvdf = detail.pvdf || false;
        transformedDetail.anodising_description =
          detail.anodising_description || undefined;
        transformedDetail.anodising_price = detail.anodising_price
          ? parseFloat(detail.anodising_price)
          : undefined;
        transformedDetail.powder_coating_description =
          detail.powder_coating_description || undefined;
        transformedDetail.powder_coating_price = detail.powder_coating_price
          ? parseFloat(detail.powder_coating_price)
          : undefined;
        transformedDetail.pvdf_description =
          detail.pvdf_description || undefined;
        transformedDetail.pvdf_price = detail.pvdf_price
          ? parseFloat(detail.pvdf_price)
          : undefined;
      }

      if (detail.jobworks && detail.jobworks.includes(5)) {
        transformedDetail.laser_marking_description =
          detail.laser_marking_description || undefined;
        transformedDetail.laser_marking_price = detail.laser_marking_price
          ? parseFloat(detail.laser_marking_price)
          : undefined;
      }

      if (detail.jobworks && detail.jobworks.includes(4)) {
        transformedDetail.out_source = Boolean(detail.out_source);
      }

      return transformedDetail;
    });

    const payload = {
      customer: values?.customer,
      workorder: values?.workorder,
      workorder_no: values.workorder_no,
      advance_amount: values.advance_amount,
      delivery_schedule: values.delivery_schedule,
      freight_charges: values.freight_charges,
      packing_mode: values.packing_mode,
      proforma_details: transformedProformaDetails,
      terms_and_condition: values.terms_and_condition,
      remarks: values.remarks,
      weight_range: values.weight_range,
    };


    dispatch(createProforma({ values: payload }))
      .unwrap()
      .then(result => {
        if (result?.success) {
          setBtnLoading(false);
          message.success('Proforma Created Successfully!');
          navigate('/proforma-list');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };
  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Create Proforma</h2>
          <div className="bredcrumbwrp">
            <Link to="/proforma-list" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/proforma-list">Proforma List</Link> },
                { title: 'Create Proforma' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          initialValues={{
            workorder_no: '',
            customer: null,
            packing_mode: [],
            proforma_date: dayjs(),
            freight_charges: '',
            advance_amount: '',
            terms_and_condition: '',
            delivery_schedule: '',
            weight_range: '',
            remarks: '',
            proforma_details: [
              {
                profile_no: null,
                alloy: null,
                temper: null,
                customer_reference_no: '',
                jobworks: null,
                length: '',
                out_source: null,
                nalco_rate: nalcoRate,
                dispatch_qty: '',
                net_weight: '',
                packed_weight: '',
                pieces: '',
              },
            ],
          }}
        >
          <Row gutter={16}>{workOrderFormItem}</Row>

          <Row gutter={16}>
            <Col xs={10} sm={8} md={4} lg={4}>
              <Form.Item
                name="workorder_no"
                label="Work Order No"
                rules={[
                  { required: true, message: 'Please enter valid work order no' },
                  {
                    patterrn: /^\d+$/,
                    message: 'Enter Only Number',
                  },
                ]}
              >
                <Input placeholder="Enter Work Order No" />
              </Form.Item>
            </Col>
            <Col xs={10} sm={10} md={4} lg={4}>
              <Form.Item
                name="customer"
                label="Customer"
                rules={[
                  { required: true, message: 'Please select customer name' },
                ]}
              >
                <AutoOpenSelect
                  value={searchCustomer}
                  placeholder="Please Select Customer"
                  onChange={handleChangeCustomer}
                  allowClear
                  showSearch={true}
                  onSearch={handleSearchCustomer}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {[
                    ...new Map(
                      customerList.map(item => [item.id, item]),
                    ).values(),
                  ].map((el, index) => (
                    <Option
                      key={el.id}
                      value={el.id}
                      disabled={el.deleted === 1}
                    >
                      {el.customer_name}
                    </Option>
                  ))}
                </AutoOpenSelect>
              </Form.Item>
            </Col>
            <Col xs={10} sm={10} md={4} lg={4}>
              <Form.Item
                name="packing_mode"
                label="Mode Of Packing"
                rules={[
                  { required: true, message: 'Please select mode of packing' },
                ]}
              >
                <AutoOpenSelect
                  placeholder="Select Mode Of Packing"
                  options={Array.from(
                    new Map(
                      packingModeList.map(item => [item.id, { label: item.name, value: item.id }])
                    ).values()
                  )}
                  mode="multiple"
                  loading={packingModeLoading}
                />
              </Form.Item>
            </Col>

            <Col xs={10} sm={8} md={4} lg={4}>
              <Form.Item
                name="proforma_date"
                label="Proforma Date"
                rules={[
                  { required: true, message: 'Please select proforma date' },
                ]}
              >
                <DatePicker format="DD-MM-YYYY" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col xs={10} sm={8} md={4} lg={4}>
              <Form.Item
                name="freight_charges"
                label="Freight Charges"
                rules={[
                  createNumberValidationRule({
                    allowNegative: false,
                    maxBeforeDecimal: 7, // Set max before decimal
                    maxAfterDecimal: 3, // Set max after decimal
                    allowDecimal: true,
                    allowZero: true,
                  }),
                ]}
              >
                <Input
                  placeholder="Enter Frieght Charges"
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ freight_charges: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={10} sm={8} md={4} lg={4}>
              <Form.Item
                name="advance_amount"
                label="Advance amount"
                rules={[
                  createNumberValidationRule({
                    allowNegative: false,
                    maxBeforeDecimal: 7, // Set max before decimal
                    maxAfterDecimal: 3, // Set max after decimal
                    allowDecimal: true,
                    allowZero: true,
                  }),
                ]}
              >
                <Input
                  placeholder="Enter Advance Amount"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}></Row>
          <div className="formrowsection">
            <h3 className="rowsubtitle">Add New Item</h3>
            <Form.List name="proforma_details">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Row
                      className="rowItem mx-0"
                      gutter={[24, 24]}
                      align="middle"
                      key={key}
                      style={{ width: '100%' }}
                    >
                      <Col flex="auto">
                        <Row gutter={16}>
                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'profile_no']}
                              placeholder="Search Section Number"
                              label="Section Number"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select a section number',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Section Number"
                                style={{ width: '100%' }}
                                labelInValue
                                value={
                                  form.getFieldValue([
                                    'proforma_details',
                                    name,
                                    'profile_no',
                                  ])
                                    ? {
                                      value: form.getFieldValue([
                                        'proforma_details',
                                        name,
                                        'profile_no',
                                      ]),
                                      label: '',
                                    }
                                    : undefined
                                }
                                onChange={value =>
                                  handleDieProfileChange(value, name)
                                }
                                onSearch={handleSearchDieProfile}
                                allowClear
                                showSearch={true}
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                loading={dieProfileLoading}
                                onPopupScroll={onScrollDieProfile}
                                notFoundContent={
                                  dieProfileLoading
                                    ? 'Loading...'
                                    : 'No options'
                                }
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {dieProfileList.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.die_number}
                                  </Option>
                                ))}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              name={[name, 'customer_reference_no']}
                              label="Customer Reference No."
                            >
                              <Input placeholder="Please enter customer Ref.No" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'alloy']}
                              label="Alloy"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select alloy',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Alloy"
                                loading={alloyLoading}
                                onPopupScroll={onScrollAlloy}
                                notFoundContent={
                                  alloyLoading ? 'Loading...' : 'No options'
                                }
                                value={
                                  form.getFieldValue([
                                    'proforma_details',
                                    name,
                                    'alloy',
                                  ])
                                    ? {
                                      value: form.getFieldValue([
                                        'proforma_details',
                                        name,
                                        'alloy',
                                      ]),
                                      label: '',
                                    }
                                    : undefined
                                }
                                onChange={value =>
                                  form.setFieldValue(
                                    ['proforma_details', name, 'alloy'],
                                    value,
                                  )
                                }
                                onSearch={handleSearchAlloy}
                                allowClear
                                showSearch={true}
                                filterOption={(input, option) => {
                                  if (!input) return true;

                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();

                                  return optionText.includes(inputText);
                                }}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {alloyList.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el?.alloy_code} - {el?.standard_name}
                                  </Option>
                                ))}
                                {alloyLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'temper']}
                              label="Temper"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select temper',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Temper"
                                loading={temperLoading}
                                onPopupScroll={onScrollTemper}
                                value={
                                  form.getFieldValue([
                                    'proforma_details',
                                    name,
                                    'temper',
                                  ])
                                    ? {
                                      value: form.getFieldValue([
                                        'proforma_details',
                                        name,
                                        'temper',
                                      ]),
                                      label: '',
                                    }
                                    : undefined
                                }
                                onChange={value =>
                                  form.setFieldValue(
                                    ['proforma_details', name, 'temper'],
                                    value,
                                  )
                                }
                                filterOption={(input, option) => {
                                  if (!input) return true;
                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  return optionText.includes(inputText);
                                }}
                                onSearch={handleSearchTemer}
                                allowClear
                                showSearch={true}
                                notFoundContent={
                                  temperLoading ? 'Loading...' : 'No options'
                                }
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {temperList.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.temper_code_new} - {el.temper_code_old}
                                  </Option>
                                ))}
                                {temperLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'length']}
                              label="Length (mm)"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter length',
                                },
                                {
                                  validator: (_, value) => {
                                    if (!value) return Promise.resolve();
                                    const regex = /^[0-9]*\.?[0-9]+$/;
                                    if (
                                      regex.test(value) &&
                                      parseFloat(value) > 0
                                    ) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      'Length must be a positive number',
                                    );
                                  },
                                },
                              ]}
                            >
                              <Input
                                placeholder="0"
                                onChange={e => {
                                  const value = e.target.value;
                                  if (
                                    /^\d{0,7}(\.\d{0,3})?$/.test(value) ||
                                    value === ''
                                  ) {
                                    form.setFieldValue(
                                      ['proforma_details', name, 'length'],
                                      value,
                                    );
                                    handleFieldChange(index, 'length');
                                  }
                                }}
                                onBlur={() => {
                                  const value = form.getFieldValue([
                                    'proforma_details',
                                    name,
                                    'length',
                                  ]);
                                  if (value) {
                                    form.setFieldValue(
                                      ['proforma_details', name, 'length'],
                                      value,
                                    );
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              name={[name, 'pieces']}
                              label="Pieces"
                              rules={[
                                {
                                  pattern: /^\d{1,6}$/,
                                  message:
                                    'Please enter a number with up to 6 digits',
                                },
                              ]}
                            >
                              <Input
                                placeholder="0"
                                onChange={e => {
                                  const value = e.target.value;
                                  if (/^\d{0,6}$/.test(value) || value === '') {
                                    form.setFieldValue(
                                      ['proforma_details', name, 'pieces'],
                                      value,
                                    );
                                    handleFieldChange(index, 'pieces');
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'net_weight']}
                              label="Net Weight (kg)"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (!value && value !== 0)
                                      return Promise.resolve();
                                    const regex = /^[0-9]*\.?[0-9]+$/;
                                    if (
                                      regex.test(value) &&
                                      parseFloat(value) >= 0
                                    ) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      'Net weight (kg) must be a positive number',
                                    );
                                  },
                                },
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 7,
                                  maxAfterDecimal: 3,
                                  allowDecimal: true,
                                  allowZero: true,
                                }),
                              ]}
                            >
                              <Input
                                placeholder="0.00"
                                onChange={e => {
                                  const value = e.target.value;
                                  if (
                                    /^\d{0,7}(\.\d{0,3})?$/.test(value) ||
                                    value === ''
                                  ) {
                                    form.setFieldValue(
                                      ['proforma_details', name, 'net_weight'],
                                      value,
                                    );
                                    handleFieldChange(index, 'net_weight');
                                  }
                                }}
                                onBlur={() => {
                                  const value = form.getFieldValue([
                                    'proforma_details',
                                    name,
                                    'net_weight',
                                  ]);
                                  if (value) {
                                    form.setFieldValue(
                                      ['proforma_details', name, 'net_weight'],
                                      parseFloat(value).toFixed(2),
                                    );
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'nalco_rate']}
                              label="Nalco Rate"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select nalco rate',
                                },
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'packed_weight']}
                              label="Packed Weight (kg)"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (!value && value !== 0)
                                      return Promise.resolve();
                                    const regex = /^[0-9]*\.?[0-9]+$/;
                                    if (
                                      regex.test(value) &&
                                      parseFloat(value) >= 0
                                    ) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      'Packed weight (kg) must be a positive number or zero',
                                    );
                                  },
                                },
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 7, // Set max before decimal
                                  maxAfterDecimal: 3, // Set max after decimal
                                  allowDecimal: true,
                                  allowZero: true,
                                }),
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'dispatch_qty']}
                              label="Dispatch Qty"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (
                                      value === undefined ||
                                      value === null ||
                                      value === ''
                                    ) {
                                      return Promise.resolve(); // Allow empty values
                                    }
                                    const regex = /^\d{1,5}$/; // Allows only digits (1 to 5 digits)
                                    if (regex.test(value.toString())) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      'Dispatch Qty must be a number with max 5 digits',
                                    );
                                  },
                                },
                              ]}
                            >
                              <Input placeholder="0" maxLength={5} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'conversion']}
                              label="Conversion"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Conversion',
                                },
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 10,
                                  maxAfterDecimal: 3,
                                  allowDecimal: true,
                                  allowZero: true,
                                }),
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>
                          <Col xs={10} md={6} xl={4} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'jobworks']}
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select jobworks',
                                },
                              ]}
                              label="Surface finish"
                            >
                              <AutoOpenSelect
                                placeholder="Select Surface finish"
                                mode="multiple"
                                onChange={value => {
                                  form.setFieldValue(['proforma_details', name, 'jobworks'], value);
                                  handleJobWorkChange(value, name)
                                }}
                                allowClear
                                showSearch
                                optionFilterProp="children"
                                value={form.getFieldValue([
                                  'proforma_details',
                                  name,
                                  'jobworks',
                                ])}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {jobWorkdata?.map(item => (
                                  <Option key={item.id} value={item.id}>
                                    {item.name}
                                  </Option>
                                ))}
                              </AutoOpenSelect>
                              {selectedJobWork[name] &&
                                selectedJobWork[name].includes(
                                  'Engineering',
                                ) && (
                                  <Space>
                                    <Form.Item
                                      name={[name, 'cutting']}
                                      valuePropName="checked"
                                      style={{ margin: '0' }}
                                    >
                                      <Checkbox
                                        style={{ marginTop: '8px' }}
                                        onChange={e =>
                                          handleCheckboxJobWorkChange(
                                            'cutting',
                                            e.target.checked,
                                            name,
                                          )
                                        }
                                      >
                                        Cutting
                                      </Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                      name={[name, 'machinings']}
                                      valuePropName="checked"
                                      style={{ margin: '0' }}
                                    >
                                      <Checkbox
                                        style={{ marginTop: '8px' }}
                                        onChange={e =>
                                          handleCheckboxJobWorkChange(
                                            'machinings',
                                            e.target.checked,
                                            name,
                                          )
                                        }
                                      >
                                        Machining
                                      </Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                      name={[name, 'deburring']}
                                      valuePropName="checked"
                                      style={{ margin: '0' }}
                                    >
                                      <Checkbox
                                        style={{ marginTop: '8px' }}
                                        onChange={e =>
                                          handleCheckboxJobWorkChange(
                                            'deburring',
                                            e.target.checked,
                                            name,
                                          )
                                        }
                                      >
                                        Deburring
                                      </Checkbox>
                                    </Form.Item>
                                  </Space>
                                )}

                              {selectedJobWork[name] &&
                                selectedJobWork[name].includes(
                                  'Surface treatment',
                                ) && (
                                  <Space>
                                    <Form.Item
                                      style={{ margin: '0' }}
                                      name={[name, 'anodising']}
                                      valuePropName="checked"
                                    >
                                      <Checkbox
                                        style={{ marginTop: '8px' }}
                                        onChange={e =>
                                          handleCheckboxJobWorkChange(
                                            'anodising',
                                            e.target.checked,
                                            name,
                                          )
                                        }
                                      >
                                        Anodising
                                      </Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                      style={{ margin: '0' }}
                                      name={[name, 'powder_coating']}
                                      valuePropName="checked"
                                    >
                                      <Checkbox
                                        style={{ marginTop: '8px' }}
                                        onChange={e =>
                                          handleCheckboxJobWorkChange(
                                            'powder_coating',
                                            e.target.checked,
                                            name,
                                          )
                                        }
                                      >
                                        Powder coating
                                      </Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                      style={{ margin: '0' }}
                                      name={[name, 'pvdf']}
                                      valuePropName="checked"
                                    >
                                      <Checkbox
                                        style={{ marginTop: '8px' }}
                                        onChange={e =>
                                          handleCheckboxJobWorkChange(
                                            'pvdf',
                                            e.target.checked,
                                            name,
                                          )
                                        }
                                      >
                                        PVDF
                                      </Checkbox>
                                    </Form.Item>
                                  </Space>
                                )}
                            </Form.Item>
                          </Col>
                          {selectedSurfaceFinish[name] &&
                            selectedSurfaceFinish[name]?.includes(
                              'anodising',
                            ) && (
                              <>
                                <Col>
                                  <Form.Item
                                    name={[name, 'anodising_description']}
                                    label="Anodising Description"
                                  >
                                    <Input placeholder="Enter Description" />
                                  </Form.Item>
                                </Col>
                                <Col>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'anodising_price']}
                                    label="Anodising Price"
                                    rules={[
                                      createNumberValidationRule({
                                        allowNegative: false,
                                        maxBeforeDecimal: 10,
                                        maxAfterDecimal: 3,
                                        allowDecimal: true,
                                        allowZero: true,
                                      }),
                                    ]}
                                  >
                                    <Input placeholder="0.0" />
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                          {selectedSurfaceFinish[name] &&
                            selectedSurfaceFinish[name]?.includes(
                              'powder_coating',
                            ) && (
                              <>
                                <Col>
                                  <Form.Item
                                    name={[name, 'powder_coating_description']}
                                    label="Powder Coating Description"
                                  >
                                    <Input placeholder="Enter Description" />
                                  </Form.Item>
                                </Col>
                                <Col>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'powder_coating_price']}
                                    label="Powder Coating Price"
                                    rules={[
                                      createNumberValidationRule({
                                        allowNegative: false,
                                        maxBeforeDecimal: 10,
                                        maxAfterDecimal: 3,
                                        allowDecimal: true,
                                        allowZero: true,
                                      }),
                                    ]}
                                  >
                                    <Input placeholder="0.0" />
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                          {selectedSurfaceFinish[name] &&
                            selectedSurfaceFinish[name]?.includes('pvdf') && (
                              <>
                                <Col>
                                  <Form.Item
                                    name={[name, 'pvdf_description']}
                                    label="pvdf Description"
                                  >
                                    <Input placeholder="Enter Description" />
                                  </Form.Item>
                                </Col>
                                <Col>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'pvdf_price']}
                                    label="pvdf Price"
                                    rules={[
                                      createNumberValidationRule({
                                        allowNegative: false,
                                        maxBeforeDecimal: 10,
                                        maxAfterDecimal: 3,
                                        allowDecimal: true,
                                        allowZero: true,
                                      }),
                                    ]}
                                  >
                                    <Input placeholder="0.0" />
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                          {selectedEngineeringOptions[name]?.includes(
                            'cutting',
                          ) && (
                              <Col>
                                <Form.Item
                                  name={[name, 'cutting_price']}
                                  label="Cutting Price"
                                  rules={[
                                    createNumberValidationRule({
                                      allowNegative: false,
                                      maxBeforeDecimal: 10,
                                      maxAfterDecimal: 3,
                                      allowDecimal: true,
                                      allowZero: true,
                                    }),
                                  ]}
                                >
                                  <Input placeholder="Enter Cutting Price" />
                                </Form.Item>
                              </Col>
                            )}
                          {selectedEngineeringOptions[name]?.includes(
                            'machinings',
                          ) && (
                              <Col>
                                <Form.Item
                                  name={[name, 'machinings_price']}
                                  label="Machining Price"
                                  rules={[
                                    createNumberValidationRule({
                                      allowNegative: false,
                                      maxBeforeDecimal: 10,
                                      maxAfterDecimal: 3,
                                      allowDecimal: true,
                                      allowZero: true,
                                    }),
                                  ]}
                                >
                                  <Input placeholder="Enter Machining Price" />
                                </Form.Item>
                              </Col>
                            )}
                          {selectedEngineeringOptions[name]?.includes(
                            'deburring',
                          ) && (
                              <Col>
                                <Form.Item
                                  name={[name, 'deburring_price']}
                                  label="Deburring Price"
                                  rules={[
                                    createNumberValidationRule({
                                      allowNegative: false,
                                      maxBeforeDecimal: 10,
                                      maxAfterDecimal: 3,
                                      allowDecimal: true,
                                      allowZero: true,
                                    }),
                                  ]}
                                >
                                  <Input placeholder="Enter Deburring Price" />
                                </Form.Item>
                              </Col>
                            )}
                          {selectedJobWork[name] &&
                            selectedJobWork[name].includes('Laser marking') && (
                              <>
                                <Col>
                                  <Form.Item
                                    name={[name, 'laser_marking_description']}
                                    label="Laser Marketing Description"
                                  >
                                    <Input placeholder="Enter Laser marking Description" />
                                  </Form.Item>
                                </Col>
                                <Col>
                                  <Form.Item
                                    name={[name, 'laser_marking_price']}
                                    label="Laser Making Price"
                                  >
                                    <Input placeholder="Enter Laser Marking Price" />
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                          {selectedJobWork[name] &&
                            selectedJobWork[name].includes('Out Source') && (
                              <Col>
                                <Form.Item
                                  name={[name, 'out_source']}
                                  label="Out Source"
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        'Please select if out source is Yes or No',
                                    },
                                  ]}
                                >
                                  <AutoOpenSelect
                                    placeholder="Select Out Source"
                                    onChange={value => {
                                      form.setFieldsValue({
                                        proforma_details: {
                                          ...form.getFieldValue(
                                            'proforma_details',
                                          ),
                                          [name]: {
                                            ...form.getFieldValue([
                                              'proforma_details',
                                              name,
                                            ]),
                                            out_source: value,
                                          },
                                        },
                                      });
                                    }}
                                  >
                                    <Option value={true}>Yes</Option>
                                    <Option value={false}>No</Option>
                                  </AutoOpenSelect>
                                </Form.Item>
                              </Col>
                            )}
                          <div className="addwrp">
                            {index !== 0 && (
                              <Button
                                type="primary"
                                danger
                                icon={<MinusCircleOutlined />}
                                onClick={() => remove(name)}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginTop: '30px',
                                }}
                              />
                            )}
                          </div>
                        </Row>
                      </Col>
                    </Row>
                  ))}
                </>
              )}
            </Form.List>
          </div>
          <Row gutter={16}>
            <Col xs={24}>
              <Form.Item
                name="terms_and_condition"
                label="Terms & Condition"
                rules={[
                  {
                    required: true,
                    message: 'Terms & Condition is required',
                  },
                ]}
                valuePropName="content"
              >
                <ReactQuill
                  value={editorValue}
                  onChange={handleChange}
                  theme="snow"
                  modules={{
                    toolbar: [
                      [{ header: '1' }, { header: '2' }, { font: [] }],
                      [{ list: 'ordered' }, { list: 'bullet' }],
                      ['bold', 'italic', 'underline'],
                      [{ align: [] }],
                      ['link', 'image'],
                      ['blockquote', 'code-block'],
                    ],
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col xs={12} sm={12} md={12} xl={8}>
              <Form.Item name="delivery_schedule" label="Delivery Schedule">
                <Input.TextArea
                  placeholder="20-25 Days for supply from the data of purchase order."
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ delivery_schedule: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={12} xl={8}>
              <Form.Item name="weight_range" label="Weight Range">
                <Input.TextArea
                  placeholder="Delivery Weight will be 10% on work order"
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ weight_range: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={12} xl={8}>
              <Form.Item name="remarks" label="Remarks">
                <Input.TextArea
                  placeholder="Enter Remark"
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ remarks: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-end">
            <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>
              Create Proforma
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default CreateProforma;